export default "./dist/stdassets/images/icons/edit-paste.png";